// src/pages/orders/OrderCreatePage/OrderCreatePage.jsx
import React from 'react'
import OrderFormPage from '../OrderFormPage/OrderFormPage'

export default function OrderCreatePage() {
  // Simply reuse OrderFormPage with isEdit = false
  return <OrderFormPage isEdit={false} />
}
